var map = {
	"./decidim/vocdoni/decidim_vocdoni.svg": "../decidim-module-vocdoni-next/app/packs/images/decidim/vocdoni/decidim_vocdoni.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../decidim-module-vocdoni-next/app/packs/images sync recursive ^\\.\\/.*$";